import { createContext } from 'react';
export const WalkthroughContext = createContext(false);
export const InvestWalkthroughContext = createContext(false);
